<div class="flex flex-col h-full min-h-0">
  <elcia-title [iconType]="'building'" [title]="customerName() || ('app.customer-sheet' | translate)"/>

  @if (isEditMode()) {
    <elcia-tabs [items]="items()"/>
  }

  @if (!isChildTabActive()) {
    <elcia-card>
      <div class="soft-scrollbar flex-1 min-h-0 overflow-y-auto pr-2">
        <elcia-company-form (paymentMethodChange)="selectedPaymentMethod.set($event)"
                            [customerId]="customerId() ?? null"
                            [form]="form"/>
      </div>
    </elcia-card>
  }

  <router-outlet/>

  <!-- Stays visible from the other tabs: the edits belong to the whole sheet, not just this tab -->
  <elcia-save-bar (onDiscard)="discard()"
                  (onSave)="submit()"
                  [isDirty]="isDirty()"
                  [isInvalid]="isInvalid()"
                  [isSaving]="isSaving()"
                  [saveLabel]="isEditMode() ? 'action.save' : 'action.create'"
                  [savedAt]="savedAt()"/>
</div>
